import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import Carousel from 'marketplace-ui-common/components/Carousel'; // @ts-expect-error untyped dependency

import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { selectCollectionsRequestState, selectDisplayedCollections } from '../../slices/collections/collectionsSlice';
import { resultCardStyles } from '../../storefront/utils/resultCardStyles';
import { getThemesStorefrontRoute } from '../../utils/urls';
import CollectionCard from './ThemeCollectionCard';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
const StyledCollectionCard = styled(CollectionCard).withConfig({
  displayName: "ThemeCollectionsCardGrid__StyledCollectionCard",
  componentId: "sc-15niv1y-0"
})(["", ""], resultCardStyles);
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "ThemeCollectionsCardGrid__StyledRouterLink",
  componentId: "sc-15niv1y-1"
})(["display:flex;align-items:stretch;"]);
export default function ThemeCollectionsCardGrid() {
  const collections = useSelector(selectDisplayedCollections);
  const collectionsRequestState = useSelector(selectCollectionsRequestState);
  const {
    maxCardsPerPage
  } = useResponsiveProps({
    maxCardsPerPage: {
      [ScreenSizes.SM]: 1,
      [ScreenSizes.MD]: 2,
      [ScreenSizes.LG]: 3
    }
  });
  const displayedCollections = useMemo(() => collections.filter(collection => !!collection.publishedListing), [collections]);
  const collectionCards = useMemo(() => displayedCollections.map(collection => collection.publishedListing && /*#__PURE__*/_jsx(StyledRouterLink, {
    style: {
      height: '100%'
    },
    to: getThemesStorefrontRoute(collection.publishedListing.slug),
    use: "unstyled",
    children: /*#__PURE__*/_jsx(StyledCollectionCard, {
      collection: collection
    })
  }, `collection-${collection.id}`)), [displayedCollections]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: collectionsRequestState,
    children: /*#__PURE__*/_jsx(Carousel, {
      cards: collectionCards,
      maxCardsPerPage: maxCardsPerPage
    })
  });
}